import api from '@/api';
import session from '@/storage/session';
import store from '@/bootstrap/vuex';

export default {
    namespaced: true,
    actions: {
        search(filters) {
            return api.get('/currencies', filters);
        },
        fetch(currencyId) {
            return api.get(`/currencies/${currencyId}`, null);
        },
        fetchCached() {
            if (session.missing('currencies')) {
                return api.fetch('/currencies', {
                    'cache-response': true,
                    'cache-key': 'currencies',
                });
            } else {
                const response = session.fetch('currencies');
                return Promise.resolve(response);
            }
        },
        fetchLists() {
            api.batch([store.dispatch('subscribers/fetchCached', null, { root: true }), store.dispatch('users/fetchCached', null, { root: true })])
                .then((response) => {
                    return Promise.resolve(response);
                })
                .catch((error) => {
                    if (error.response) {
                        return Promise.reject(error.response);
                    }
                    return Promise.reject(null);
                });
        },
        save(currency) {
            return api
                .post('/currencies', currency)
                .then((response) => {
                    session.destroy('currency');
                    return Promise.resolve(response);
                })
                .catch((error) => {
                    if (error.response) {
                        return Promise.reject(error.response);
                    }
                    return Promise.reject(null);
                });
        },
        update(currencyId, currency) {
            return api
                .put(`/currencies/${currencyId}`, currency)
                .then((response) => {
                    session.destroy('currency');
                    return Promise.resolve(response);
                })
                .catch((error) => {
                    if (error.response) {
                        return Promise.reject(error.response);
                    }
                    return Promise.reject(null);
                });
        },
        archive(currencyId) {
            return api.put(`/currencies/archive/${currencyId}`, null);
        },
        delete(currencyId) {
            return api.delete(`/currencies/${currencyId}`, null);
        },
    },
};
